"use client";

import * as React from "react";
import Link from "next/link";
import { AppBar, Toolbar, Typography, Box } from "@mui/material";
import HeaderButtons from "./HeaderButtons";

type HeaderProps = {
  isAuthed: boolean;
  appBase: string;
  apiOrigin: string;
};

const Header: React.FC<HeaderProps> = ({ isAuthed, appBase, apiOrigin }) => {
  return (
    <AppBar position="static">
      <Toolbar
        sx={{
          justifyContent: { xs: "center", md: "flex-start" },
          position: "relative",
        }}
      >
        <Link href="/" style={{ textDecoration: "none", color: "inherit" }}>
          {/* Site wordmark — branding/nav, not document structure. `h6`
              variant is kept only for its visual scale; rendered as a
              <span> so it never competes with a page's real <h1>. */}
          <Typography
            variant="h6"
            component="span"
            sx={{ fontWeight: 600, letterSpacing: 1 }}
          >
            LEODEO
          </Typography>
        </Link>
        <Box
          sx={{
            position: { xs: "absolute", md: "static" },
            right: { xs: 8, md: "auto" },
            ml: { md: "auto" },
          }}
        >
          <HeaderButtons
            isAuthed={isAuthed}
            appBase={appBase}
            apiOrigin={apiOrigin}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
